module.exports = __webpack_public_path__ + "static/media/realtalk_sd_minatocaba312ad78bb78dc44486bfaeb667f6.webp";